export const TURKEY_COUNTRY_CODE = "TR";
export const TURKEY_SA_COUNTRY_CODE = "TUR";
export const TURKEY_LOCALSITE_LINK = "https://kvkk-portal.samsung.com";
